"use client";

import { ChartContextType, ChartProvider } from "./ChartProvider";
import { Chart } from "./Chart";

export const ShortsworksChart = (props: ChartContextType) => {
  return (
    <ChartProvider {...props}>
      <Chart />
    </ChartProvider>
  );
};
